import axios from "axios";
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import "./css/main.login.css";
import Register from "../register/Register";

const Login: React.FC = () => {
  const [isShowLoginForm, setIsShowLoginForm] = useState(true);
  const [isLogin, setIsLogin] = useState(true);
  const [isRegister, setIsRegister] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  // Kiểm tra token khi component mount
  useEffect(() => {
    const token = Cookies.get("access_token");
    const userInfo = localStorage.getItem("user_info");
    
    // Nếu đã có token và user info, redirect ngay
    if (token && userInfo) {
      try {
        const user = JSON.parse(userInfo);
        if (user.role === "SUPERADMIN" || user.role === "ADMIN") {
          window.location.href = "/admin";
        } else {
          window.location.href = "/homeNH";
        }
      } catch (e) {
        // Nếu parse lỗi, clear và ở lại trang login
        Cookies.remove("access_token");
        localStorage.removeItem("user_info");
      }
    }
  }, []);

  const handleLogin = async (e?: React.FormEvent) => {
    // Prevent default form submission
    if (e) {
      e.preventDefault();
    }

    if (userName.trim() === "" || password.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Lỗi đăng nhập",
        text: "Vui lòng điền đầy đủ thông tin",
        customClass: {
          popup: "custom-swal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
      return;
    }

    try {
      Swal.fire({
        title: "Đang xử lý...",
        text: "Vui lòng đợi giây lát",
        customClass: {
          popup: "custom-swal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      await new Promise((resolve) => setTimeout(resolve, 1000));

      const data = await axios.post(
        `${process.env.REACT_APP_URL_API}/auth/login`,
        {
          username: userName,
          password,
        }
      );

      // Persist session info before navigating so route guards see it immediately
      localStorage.setItem(
        "user_info",
        JSON.stringify({
          userName: data.data.user.username,
          coins: data.data.user.coins,
          role: data.data.user.role,
          id: data.data.user._id,
        })
      );

      // Some parts still read token from localStorage; keep in sync
      localStorage.setItem("access_token", data.data.access_token);

      // Only set secure cookie on HTTPS; in dev (http) secure cookies are ignored
      const isSecure = window.location.protocol === "https:";
      Cookies.set("access_token", data.data.access_token, {
        expires: 1 / 24,
        secure: isSecure,
        sameSite: "Strict",
      });

      // Đóng tất cả modals ngay lập tức
      setIsShowLoginForm(false);
      setIsLogin(false);
      setIsRegister(false);

      if (
        (data.status === 201 && data.data.user.role === "SUPERADMIN") ||
        data.data.user.role === "ADMIN"
      ) {
              // Hiện thông báo đẹp và tự động redirect sau 0.5 giây
              Swal.fire({
                html: `
                  <div style="text-align: center; padding: 20px;">
                    <div style="
                      width: 80px; 
                      height: 80px; 
                      background: linear-gradient(135deg, #10b981, #059669);
                      border-radius: 50%; 
                      display: flex; 
                      align-items: center; 
                      justify-content: center; 
                      margin: 0 auto 20px;
                      box-shadow: 0 0 30px rgba(16, 185, 129, 0.5);
                      animation: successPulse 1s ease-in-out infinite;
                    ">
                      <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                        <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                              stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <h2 style="
                      color: #10b981; 
                      font-size: 24px; 
                      font-weight: bold; 
                      margin: 0 0 10px 0;
                      text-shadow: 0 0 10px rgba(16, 185, 129, 0.3);
                    ">Đăng nhập thành công!</h2>
                    <p style="
                      color: rgba(255, 255, 255, 0.9); 
                      font-size: 16px; 
                      margin: 0 0 15px 0;
                    ">Chào mừng Admin trở lại!</p>
                    <div style="
                      width: 100%; 
                      height: 4px; 
                      background: rgba(16, 185, 129, 0.2); 
                      border-radius: 2px; 
                      overflow: hidden;
                    ">
                      <div style="
                        width: 100%; 
                        height: 100%; 
                        background: linear-gradient(90deg, #10b981, #059669); 
                        border-radius: 2px;
                        animation: loadingBar 0.5s ease-out;
                      "></div>
                    </div>
                  </div>
                  <style>
                    @keyframes successPulse {
                      0%, 100% { transform: scale(1); }
                      50% { transform: scale(1.05); }
                    }
                    @keyframes loadingBar {
                      0% { width: 0%; }
                      100% { width: 100%; }
                    }
                  </style>
                `,
                customClass: {
                  popup: "bg-custom-image",
                },
                timer: 500,
                showConfirmButton: false,
                allowOutsideClick: false,
              });
              // Tự động redirect sau 0.5 giây
              setTimeout(() => {
                window.location.href = "/admin";
              }, 500);
            } else {
              // Hiện thông báo đẹp (tone đỏ-cam) và tự động redirect sau 0.5 giây
              Swal.fire({
                html: `
                  <div style="text-align: center; padding: 24px 20px;">
                    <div style="
                      width: 80px; 
                      height: 80px; 
                      background: conic-gradient(from 220deg, #fee2e2, #fed7aa, #f97316, #b91c1c);
                      border-radius: 50%; 
                      display: flex; 
                      align-items: center; 
                      justify-content: center; 
                      margin: 0 auto 20px;
                      box-shadow: 0 0 32px rgba(248, 113, 113, 0.7);
                      animation: successPulse 1s ease-in-out infinite;
                      border: 2px solid rgba(248, 113, 113, 0.95);
                    ">
                      <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                        <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                              stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <h2 style="
                      color: #fee2e2; 
                      font-size: 24px; 
                      font-weight: bold; 
                      margin: 0 0 10px 0;
                      text-shadow: 0 0 18px rgba(248, 113, 113, 0.9);
                    ">Đăng nhập thành công!</h2>
                    <p style="
                      color: rgba(255, 247, 237, 0.95); 
                      font-size: 16px; 
                      margin: 0 0 15px 0;
                    ">Đang chuyển hướng...</p>
                    <div style="
                      width: 100%; 
                      height: 4px; 
                      background: rgba(248, 113, 113, 0.25); 
                      border-radius: 2px; 
                      overflow: hidden;
                    ">
                      <div style="
                        width: 100%; 
                        height: 100%; 
                        background: linear-gradient(90deg, #dc2626, #ea580c); 
                        border-radius: 2px;
                        animation: loadingBar 0.5s ease-out;
                      "></div>
                    </div>
                  </div>
                  <style>
                    @keyframes successPulse {
                      0%, 100% { transform: scale(1); }
                      50% { transform: scale(1.05); }
                    }
                    @keyframes loadingBar {
                      0% { width: 0%; }
                      100% { width: 100%; }
                    }
                  </style>
                `,
                customClass: {
                  popup: "bg-custom-image",
                },
                timer: 500,
                showConfirmButton: false,
                allowOutsideClick: false,
              });
              
              // Tự động redirect sau 0.5 giây
              setTimeout(() => {
                window.location.href = "/homeNH";
              }, 500);
            }
    } catch (err: any) {
      const status = err?.response?.status;
      if (status === 401) {
        Swal.fire({
          icon: "error",
          title: "Lỗi đăng nhập",
          text: "Tài khoản/mật khẩu không chính xác!",
          customClass: {
            popup: "custom-swal",
            title: "custom-title",
            htmlContainer: "custom-text",
          },
        });
        return;
      }
      Swal.fire({
        icon: "error",
        title: "Lỗi",
        text: "Có lỗi xảy ra, vui lòng thử lại.",
        customClass: {
          popup: "custom-swal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
    }
  };

  return (
    <div className="login-page ">
      <div className="bgLogin">
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: -1,
            backgroundSize: "contain",
            backgroundRepeat: "repeat",
            backgroundPosition: "top",
          }}
        >
          <source
            src={window.innerWidth <= 430 ? "/assets/bg-mb.mov" : "/assets/bg-pc.mov"}
            type="video/mp4"
          />
        </video>
      </div>
      <div className={`model-group ${isRegister ? "active" : ""}`}>
        <div className="overlay" />

        <Register
          isRegister={isRegister}
          setIsShowLogin={() => setIsLogin(true)}
          setIsRegister={() => setIsRegister(false)}
        />
      </div>

      <div
        className="index-page_wrapper"
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
      >
        <div id="bg-canvas">
          <canvas
            className="particles-js-canvas-el"
            width="1366"
            height="641"
          />
        </div>
        <div
          className="logo"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: 'auto',
            maxWidth: '100%',
          }}
        >
          <img
            src="/assets/logo-nohu.png"
            width={300}
            height={600}
            alt="logo"
            className="logo_main"
            style={{ position: 'static', transform: 'none', left: 'auto', top: 'auto', maxWidth: '100%', height: 'auto' }}
            onError={(ev) => { (ev.currentTarget as HTMLImageElement).style.display = 'none'; }}
          />
          {/* Form đăng nhập ngay dưới logo */}
          {!isRegister && (
            <div
              className="login-form-box"
              style={{
                width: 487,
                maxWidth: '95vw',
                boxSizing: 'border-box',
                background: '#430000E5',
                border: '2px solid #dc2626',
                borderRadius: '12px',
                padding: '24px 28px',
                marginTop: 24,
                boxShadow:
                  '0 0 30px rgba(220, 38, 38, 0.25), inset 0 0 60px rgba(0,0,0,0.2)',
                fontFamily: "'Courier New', monospace",
              }}
            >
            <h2
              style={{
                textAlign: 'center',
                color: '#fff',
                fontSize: 22,
                fontWeight: 'bold',
                marginBottom: 20,
                textShadow: '0 0 12px rgba(255,255,255,0.4)',
                letterSpacing: '2px',
              }}
            >
              ĐĂNG NHẬP
            </h2>

            <form onSubmit={handleLogin} style={{ textAlign: 'center' }}>
              <div style={{ marginBottom: 16 }}>
                <label
                  style={{
                    display: 'block',
                    color: 'rgba(255,255,255,0.9)',
                    fontSize: 13,
                    marginBottom: 6,
                    textAlign: 'left',
                    fontWeight: 'bold',
                  }}
                >
                  TÀI KHOẢN:
                </label>
                <input
                  type="text"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  placeholder="Nhập tên đăng nhập"
                  maxLength={16}
                  minLength={4}
                  autoComplete="username"
                  required
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    background: '#420101',
                    border: '1px solid #dc2626',
                    borderRadius: '8px',
                    color: '#fff',
                    fontSize: 14,
                    fontFamily: "'Courier New', monospace",
                    outline: 'none',
                    boxSizing: 'border-box',
                  }}
                />
              </div>

              <div style={{ marginBottom: 18 }}>
                <label
                  style={{
                    display: 'block',
                    color: 'rgba(255,255,255,0.9)',
                    fontSize: 13,
                    marginBottom: 6,
                    textAlign: 'left',
                    fontWeight: 'bold',
                  }}
                >
                  MẬT KHẨU:
                </label>
                <div style={{ position: 'relative' }}>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Nhập mật khẩu"
                    maxLength={16}
                    minLength={4}
                    autoComplete="current-password"
                    required
                    style={{
                      width: '100%',
                      padding: '10px 36px 10px 12px',
                      background: '#420101',
                      border: '1px solid #dc2626',
                      borderRadius: '8px',
                      color: '#fff',
                      fontSize: 14,
                      fontFamily: "'Courier New', monospace",
                      outline: 'none',
                      boxSizing: 'border-box',
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword((v) => !v)}
                    style={{
                      position: 'absolute',
                      right: 10,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: 4,
                      color: 'rgba(255,255,255,0.7)',
                    }}
                    aria-label={showPassword ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'}
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      {showPassword ? (
                        <>
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                          <line x1="1" y1="1" x2="23" y2="23" />
                        </>
                      ) : (
                        <>
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </>
                      )}
                    </svg>
                  </button>
                </div>
              </div>

              <button
                type="submit"
                style={{
                  width: '100%',
                  padding: '14px',
                  background: 'linear-gradient(90deg, #dc2626, #ea580c)',
                  border: 'none',
                  borderRadius: '8px',
                  color: '#fff',
                  fontSize: 15,
                  fontWeight: 'bold',
                  fontFamily: "'Courier New', monospace",
                  cursor: 'pointer',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  marginBottom: 16,
                  boxShadow: '0 2px 8px rgba(220,38,38,0.4)',
                }}
              >
                [ Bắt đầu đăng nhập ]
              </button>
            </form>

            <div style={{ textAlign: 'center' }}>
              <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: 13, marginBottom: 6 }}>
                NGƯỜI DÙNG MỚI?
              </p>
              <span
                role="button"
                tabIndex={0}
                onClick={() => setIsRegister(true)}
                onKeyDown={(e) => e.key === 'Enter' && setIsRegister(true)}
                style={{
                  color: '#facc15',
                  fontSize: 14,
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  textDecoration: 'underline',
                }}
              >
                &gt;&gt; ĐĂNG KÝ TÀI KHOẢN &lt;&lt;
              </span>
            </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
